<template>
    <div class="chart">
        <apexchart
          type="donut"
          height="176"
          :options="chartOptions"
          :series="project"
        ></apexchart>
      </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { TherapyStats, IntakeStatus } from '@/utils/models/therapy.model';

export default defineComponent({
    name: 'DayIntakeStatsChart',
    props: {
        stats: {} as TherapyStats
    } as any,
    data: function () {
    return {
      project: [this.$props.stats.waiting_response, this.$props.stats.taken_in_time, this.$props.stats.taken_not_in_time, this.$props.stats.not_taken],
      chartOptions: {
        chart: {
          type: "donut",
        },
        plotOptions: {
          pie: {
            donut: {
              size: "75%",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 4,
        },
        colors: ["#006EAB", "#06B48A", "#F3C44C", "#EF2929"],
        legend: {
          show: false
        },
        labels: [this.$t(`feature.therapy.intake.$status.${IntakeStatus.waiting}`), this.$t(`feature.therapy.intake.$status.${IntakeStatus.taken_in_time}`), this.$t(`feature.therapy.intake.$status.${IntakeStatus.taken_not_in_time}`), this.$t(`feature.therapy.intake.$status.${IntakeStatus.not_taken}`)],
        tooltip: {
          style: {
            fontSize: "14px",
            // fontFamily: "Red Hat Display, sans-serif",
          },
        },
      },
    };
  },
});
</script>